import { Vehicle } from 'types/vehicle';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';
import styled from 'styled-components';
import { ReserveLabel } from 'components/ReserveLabel';
import { ActionDivider } from '../../../../UI';
import { ReservePriceLabel } from 'components/ReservePriceMet';
import { useScreen, useWindowSize } from 'usehooks-ts';

type Props = {
  vehicle: Vehicle;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  align-items: 100%;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #212121;
  max-width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ReservePrice = ({ vehicle }: Props) => {
  const { width = 0 } = useWindowSize();
  const isMobile = width < 1024;
  if (!vehicle.reserve_price_set) return null;

  const label = `Reserve price - ${formatCurrency(vehicle.reserve_price)}`;

  return (
    <>
      <Wrapper>
        <Label>{label}</Label>
        <ReservePriceLabel activeVehicle={vehicle} styleOverrides={{ width: isMobile ? '160px' : '180px' }} />
      </Wrapper>
      <ActionDivider />
    </>
  );
};
